import RolloverMenu from '../../../../../../../com/rolloverMenu/RolloverMenu'

import './SettingsControlsMenu.scss'
import React from "react";
import {Box, Typography} from "@mui/material";

interface ISettingsControls {
    show: boolean;
    target: any;
    onHide: () => void;
    showGuiThemeSettings: () => void;
    showCheckoutSettings?: () => void;
    showSaleTypesSettings?: () => void;
    showAccountLocalSettings?: () => void;
    showFlyerClassesPopup?: () => void;
    showEmailSettingsPopup?: () => void;
    showStoreSettingsPopup?: () => void;
    showUsersAndPermissionsPopup?: () => void;
}

const SettingsControls: React.FC<ISettingsControls> = (props) => {

    return (
        <div className="settings_controls_rollover_menu_container">
            <RolloverMenu
                show={props.show}
                target={props.target}
                onHide={() => props.onHide()}
                placement="bottom-start"
            >
                <Box
                    sx={{
                        display: "flex",
                        flexFlow: "column",
                        rowGap: "12px",
                        cursor: "default",
                        "& > .MuiTypography-root": {
                            cursor: "pointer",
                            fontSize: "14px"
                        }
                    }}
                >
                    <Typography
                        fontSize={"14px"}
                        fontWeight={"700"}
                        sx={{
                            textDecoration: "underline",
                            cursor: "default!important"
                        }}
                    >
                        Account Settings
                    </Typography>
                    <Typography onClick={props.showGuiThemeSettings}>Brands</Typography>
                    <Typography onClick={props.showFlyerClassesPopup}>Flyer Classes</Typography>
                    <Typography onClick={props.showAccountLocalSettings}>Startup Options</Typography>
                    <Typography onClick={props.showCheckoutSettings}>Checkout Options</Typography>
                    <Typography onClick={props.showEmailSettingsPopup}>Email Settings</Typography>
                    <Typography onClick={props.showSaleTypesSettings}>Sale Types</Typography>
                    <Typography onClick={props.showStoreSettingsPopup}>Store Settings</Typography>
                    <Typography onClick={props.showUsersAndPermissionsPopup}>Users & Permissions</Typography>
                </Box>
            </RolloverMenu>
        </div>
    );
}

export default SettingsControls;